import setSliderSettings from '../../js/admin/components/slider.js';

window.addEventListener( 'load', () => {

	/**
	 * Initialize slider
	 *
	 * @param {object} block
	 */
	const initSlider = ( block ) => {

		const slider = block.querySelector( '.mnc-slider-container' );

		if ( slider ) {

			setSliderSettings( slider );

		}

	}

	/**
	 * Set current letter
	 *
	 * @param {object} block
	 */
	const setCurrentLetter = ( block ) => {

		const letters = block.querySelectorAll( '.table-of-content__letter' );
		const currentLetter = window.location.hash;

		if ( letters.length > 0 ) {

			document.querySelector( 'html' ).style.scrollBehavior = 'smooth';

			letters.forEach( ( letter ) => {

				if ( currentLetter && letter.innerText.toLowerCase() === currentLetter.slice( 1 ).toLowerCase() ) {

					letter.classList.add( 'current-letter' );

				}

				letter.addEventListener( 'click', () => {

					if ( letter.classList.contains( 'has-phrases' ) ) {

						const clickedLetter = block.querySelector( '.current-letter' );

						if ( clickedLetter ) {

							clickedLetter.classList.remove( 'current-letter' );

						}

						letter.classList.add( 'current-letter' );

					}

				} );

			} );

		}

	}

	/**
	 * Init block settings
	 *
	 * @type {string}
	 */
	const init = () => {

		const blocks = document.querySelectorAll( '.b-a-z-index' );

		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initSlider( block );
				setCurrentLetter( block );

			} );

		}

	}

	init();


} );






